import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <Logo />
            <p className="footer-description">
              Empowering businesses through innovative technology solutions and expert consultation.
            </p>
            <div className="footer-social">
              <a href="#" aria-label="LinkedIn"><i className="social-icon">in</i></a>
              <a href="#" aria-label="Twitter"><i className="social-icon">tw</i></a>
              <a href="#" aria-label="GitHub"><i className="social-icon">gh</i></a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services#software">Software Development</Link></li>
              <li><Link to="/services#consultancy">Consultancy Services</Link></li>
              <li><Link to="/services#procurement">IT Equipment Procurement</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <ul className="footer-contact">
              <li>📧 info@mndinitech.co.za</li>
              <li>📞 +27 (0) 11 123 4567</li>
              <li>📍 Johannesburg, South Africa</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Mndini Technologies. All rights reserved.</p>
          <div className="footer-legal">
            <a href="#">Privacy Policy</a>
            <span>|</span>
            <a href="#">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
